import { render, staticRenderFns } from "./FormPermohonan.vue?vue&type=template&id=5ede22a0&"
import script from "./FormPermohonan.vue?vue&type=script&lang=js&"
export * from "./FormPermohonan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports